export interface IllustrationProps {
  size?: keyof typeof illustrationSizes;
  title?: string;
}

// Note: for now, these value stay co-located to the icons.
// But with the global rework of size & spacing of UI, this should be moved
export const illustrationSizes = {
  s: 124,
  m: 240,
  l: 335,
};
